<template>
    <v-card>
        <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
        ></v-text-field>
        </v-card-title>

        <v-data-table
        :headers="headers"
        :items="records"
        :search="search" 
        group-by="school_arm.type"
        :options="{
        itemsPerPage: 50
        }"
        dense
        >

            <template v-slot:item.actions="{ item }">
                <v-btn @click="editRecord(item)" fab light x-small class="mr-2">
                    <v-icon
                        small
                    >
                        mdi-pencil
                    </v-icon>
                </v-btn>
                <v-btn v-if="item.has_students == 0" @click="deleteRecord(item)" fab color="error" x-small>
                    <v-icon
                        small
                    >
                        mdi-trash-can-outline
                    </v-icon>
                </v-btn>
            </template>
    
        </v-data-table>
    </v-card>
</template>
<script>
import axios from 'axios';
  export default {
    name: 'ClassesTableList',
    props:[
        'authToken',
        'school',
        'records',
        'schoolarms'
    ],
    mounted() {
       //
    },
    data: () => ({
        editFormSignal: false,
        search: '',
        headers: [
          { value: 'class', text: 'Class Name' },
          { value: 'school_arm.type', text: 'School Arm' },
          { value: 'teacher_name', text: 'Teacher' },
          { value: 'actions', text: 'Actions', sortable: false },
        ],
    }),
    watch:{
        //
    },
    methods: {
        editRecord (record) {
            this.$emit("editFormSignal", record); // Emit the event with data or response 
        },

        deleteRecord (record) {
            if(confirm("Do you really want to delete?")){
                let loader = this.$loading.show()
                axios.delete(process.env.VUE_APP_BASEURL+'/classes/'+record.class_id+'?school_id='+this.school.school_id+'&confirm=DELETE',{
                    headers: 
                    {
                        'Authorization': 'Bearer '+this.authToken
                    }
                })
                .then(response => {
                     this.$toast.success(response.data.message, {
                        timeout: 5000
                    }); 
                    this.$emit("refreshSignal", "yes"); // Emit the event with data or response 
                })
                .catch(error => {
                    this.$toast.error(error.response ? error.response.data.message : 'Network Error, Please try again few minutes', {
                    timeout: 5000
                    });
                })
                .finally(() => {
                    loader.hide()
                });
            }
        }
    },
  }
</script>